import React, { useState, useEffect, Fragment, useCallback } from "react";
import localization from "assets/localization/localization";
import DivLayout from "components/sales/divLayout/divLayout";
import DocumentView from "../../../../../../components/sales/downloadDocView/documentView";
import Layout from "../../../../../../components/sales/layout/layout";
import { toast } from "react-toastify";
import { Button } from "react-bootstrap";
import RTODocuments from "../Documents/RtoDocuments";
import ModalPop from "components/sales/modal/modal";
import FormSection from "components/sales/formSection/formSection";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import FileUpload from "components/sales/fileUpload/fileUpload";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import s from "../../../../../../components/sales/paymentPortal/addPayment/addPayment.module.css";

const RTOCaseView = ({
  caseByIdRequest,
  match,
  loanApplicationByIdRequest,
  loanApplicationByIdResponse = [],
  rcCaseByIdRequest,
  caseStatusUpdateResponse = [],
  documentUploadUrlPublic,
  documentUrlDataPublic,
  rcCaseByIdResponse = [],
  rtoDetailsUpdateRequest,
  rtoDetailsUpdateResponse = [],
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [id, setId] = useState("");
  const [roleId, setRoleId] = useState();
  const [userId, setUserId] = useState();
  const [inputList, setInputList] = useState([]);
  const [changeCarLoanStatusModalOpen, setChangeCarLoanStatusModalOpen] =
    useState(false);
  const [documentCollectedConfirm, setDocumentCollectedConfirm] =
    useState(false);
  const [rtoInputList, setRtoInputList] = useState([
    {
      document_status: "",
      rto_amount: "",
      challan_exists: "",
      challan_document: "",
      remark: "",
      document_confirmation: "",
      documents: [],
      agent_name: "",
      agent_number: "",
      agent_email: "",
      mediator: ""
    },
  ]);

  useEffect(() => {
    setIsLoading(true);
    (async () => {
      setUserId(JSON.parse(window.localStorage.loginDetails)?.id);
      setRoleId(window.localStorage.getItem("fusion-role"));
      await caseByIdRequest(match?.params?.loan_id);
      await loanApplicationByIdRequest(match?.params?.loan_id);
      await rcCaseByIdRequest(match?.params?.application_id);
    })();
    setIsLoading(false);
  }, []);

  const headerBtns = () => {
    return (
      <Fragment>
        <Button
          onClick={() => {
            setChangeCarLoanStatusModalOpen(true);
          }}
          className="filter-hamburger btn btn-transparent"
        >
          {"Change Status"}
        </Button>
        <Button
          onClick={(e) => {
            handleRTODetailsSubmit(e);
          }}
          className="filter-hamburger btn btn-transparent"
        >
          {"Submit"}
        </Button>
      </Fragment>
    );
  };

  const handleInput = (val, key, type, id, index) => {
    if (!val) return;
    let list = [...inputList];
    if (!list[index]) {
      list[index] = {};
    }
    list[index]["url"] = val;
    list[index]["type"] = type;
    if (id) {
      list[index]["document_id"] = id;
    }
    setInputList(list);
  };

  const handleRtoInput = (key, val) => {
    if (!val) return;
    let list = [...rtoInputList];
    if (key === "status") {
      if (val === "ORIGINAL_DOCUMENT_APPROVED") {
        setDocumentCollectedConfirm(true);
      } else {
        setDocumentCollectedConfirm(false);
      }
    }

    if (key === "RTO_RECEIPT") {
      list[0]["documents"][list[0]["documents"].length] = {
        url: val,
        type: 19,
      };
    }

    if (key === "RC_TRANSFER_PROOF") {
      list[0]["documents"][list[0]["documents"].length] = {
        url: val,
        type: 20,
      };
    }

    if (key === "CHALLAN") {
      list[0]["documents"][list[0]["documents"].length] = {
        url: val,
        type: 18,
      };
    }

    list[0][key] = val;
    setRtoInputList(list);
  };

  const handleRTODetailsSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    rtoInputList[0]["id"] = match?.params?.application_id;
    if (inputList.length > 0) {
      rtoInputList[0]["documents"] = inputList;
    }
    rtoInputList[0]["is_status_update"] = false;
    // return ;
    await rtoDetailsUpdateRequest(rtoInputList[0]);
    setIsLoading(false);
  };

  useEffect(() => {
    if (parseInt(rtoDetailsUpdateResponse?.status) === 200) {
      toast.success(rtoDetailsUpdateResponse?.message);
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } else if (parseInt(rtoDetailsUpdateResponse?.status) !== 200) {
      toast.error(rtoDetailsUpdateResponse?.message);
    }
  }, [rtoDetailsUpdateResponse]);

  const submitStatus = async () => {
    rtoInputList[0]["id"] = match?.params?.application_id;

    rtoInputList[0]["is_status_update"] = true;
    // if (!rtoInputList[0]?.remark) {
    //   toast.error("Remark is required");
    //   return false;
    // }

    if (
      rtoInputList[0]["document_status"] === "ORIGINAL_DOCUMENT_APPROVED" &&
      !rtoInputList[0]["document_confirmation"]
    ) {
      toast.error("Please confirm all documents has been uploaded!");
      return false;
    }

    if (rtoInputList[0]["document_status"] === "RTO_APPROVED") {
      const isUpload = rtoInputList[0]["documents"].filter(
        (val) => val.type === 19
      );
      // if (isUpload.length === 0) {
      //   toast.error("RTO Receipt is required please upload!");
      //   return false;
      // }
    }

    if (rtoInputList[0]["document_status"] === "RTO_APPROVED") {
      const isUpload = rtoInputList[0]["documents"].filter(
        (val) => val.type === 20
      );
      if (isUpload.length === 0) {
        toast.error("Screenshot of vahan is required please upload!");
        return false;
      }
    }

    setIsLoading(true);
    await rtoDetailsUpdateRequest(rtoInputList[0]);
    setIsLoading(false);
  };

  useEffect(() => {
    if (parseInt(caseStatusUpdateResponse?.status) === 200) {
      toast.success(caseStatusUpdateResponse?.message);
      setChangeCarLoanStatusModalOpen(false);
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } else if (caseStatusUpdateResponse?.status !== 200) {
      toast.error(caseStatusUpdateResponse?.message);
    }
  }, [caseStatusUpdateResponse]);

  return (
    <Layout
      title={localization.BacktoList}
      isGoback
      isLoading={isLoading}
      Buttons={headerBtns}
    >
      <Fragment>
        {loanApplicationByIdResponse?.data && (
          <>
            <div className="panel-card">
              <div className="panel-heading">Case Details</div>
              <div className="panel-body">
                <div className="details-listing">
                  {loanApplicationByIdResponse?.data && (
                    <>
                      <div className="row">
                        {/*<div className="col-6">*/}
                        {/*    <DivLayout*/}
                        {/*        heading={"Unique Id"}*/}
                        {/*        data={*/}
                        {/*            loanApplicationByIdResponse?.data*/}
                        {/*                ?.ucd_dealer_case_id*/}
                        {/*                ? loanApplicationByIdResponse?.data*/}
                        {/*                    ?.ucd_dealer_case_id*/}
                        {/*                : localization.na*/}
                        {/*        }*/}
                        {/*    />*/}
                        {/*</div>*/}
                        {/*<div className="col-6">*/}
                        {/*    <DivLayout*/}
                        {/*        heading={"Business Name"}*/}
                        {/*        data={*/}
                        {/*            loanApplicationByIdResponse?.data?.business_name*/}
                        {/*                ? loanApplicationByIdResponse?.data*/}
                        {/*                    ?.business_name*/}
                        {/*                : localization.na*/}
                        {/*        }*/}
                        {/*    />*/}
                        {/*</div>*/}
                        <div className="col-6">
                          <DivLayout
                            heading={"Vehicle Type"}
                            data={
                              loanApplicationByIdResponse?.data?.vehicle_type
                                ? loanApplicationByIdResponse?.data
                                    ?.vehicle_type
                                : localization.na
                            }
                          />
                        </div>
                        <div className="col-6">
                          <DivLayout
                            heading={"Entity Type"}
                            data={
                              loanApplicationByIdResponse?.data?.customer_type
                                ? loanApplicationByIdResponse?.data
                                    ?.customer_type
                                : localization.na
                            }
                          />
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>

            {loanApplicationByIdResponse?.data &&
              loanApplicationByIdResponse?.data?.primary &&
              loanApplicationByIdResponse?.data?.primary &&
              loanApplicationByIdResponse?.data?.primary?.meta_data && (
                <>
                  <div className="panel-card">
                    <div className="panel-heading">Customer Details</div>
                    <div className="panel-body">
                      <div className="details-listing">
                        <div className="row">
                          <div className="col-6">
                            <DivLayout
                              heading={"Customer First Name"}
                              data={
                                loanApplicationByIdResponse?.data?.primary
                                  ?.meta_data?.first_name
                                  ? loanApplicationByIdResponse?.data?.primary
                                      ?.meta_data?.first_name
                                  : localization.na
                              }
                            />
                          </div>
                          <div className="col-6">
                            <DivLayout
                              heading={"Customer Last Name"}
                              data={
                                loanApplicationByIdResponse?.data?.primary
                                  ?.meta_data?.last_name
                                  ? loanApplicationByIdResponse?.data?.primary
                                      ?.meta_data?.last_name
                                  : localization.na
                              }
                            />
                          </div>
                          <div className="col-6">
                            <DivLayout
                              heading={"Customer Mother Name"}
                              data={
                                loanApplicationByIdResponse?.data?.primary
                                  ?.meta_data?.customer_mother_name
                                  ? loanApplicationByIdResponse?.data?.primary
                                      ?.meta_data?.customer_mother_name
                                  : localization.na
                              }
                            />
                          </div>
                          <div className="col-6">
                            <DivLayout
                              heading={"D.O.B."}
                              data={
                                loanApplicationByIdResponse?.data?.primary
                                  ?.meta_data?.date_of_birth
                                  ? loanApplicationByIdResponse?.data?.primary
                                      ?.meta_data?.date_of_birth
                                  : localization.na
                              }
                            />
                          </div>
                          <div className="col-6">
                            <DivLayout
                              heading={"Gender"}
                              data={
                                loanApplicationByIdResponse?.data?.primary
                                  ?.meta_data?.gender
                                  ? loanApplicationByIdResponse?.data?.primary
                                      ?.meta_data?.gender
                                  : localization.na
                              }
                            />
                          </div>
                          <div className="col-6">
                            <DivLayout
                              heading={"Email"}
                              data={
                                loanApplicationByIdResponse?.data?.primary
                                  ?.meta_data?.email
                                  ? loanApplicationByIdResponse?.data?.primary
                                      ?.meta_data?.email
                                  : localization.na
                              }
                            />
                          </div>
                          <div className="col-6">
                            <DivLayout
                              heading={"Current Address"}
                              data={
                                loanApplicationByIdResponse?.data?.primary
                                  ?.meta_data?.current_address
                                  ? loanApplicationByIdResponse?.data?.primary
                                      ?.meta_data?.current_address
                                  : localization.na
                              }
                            />
                          </div>
                          <div className="col-6">
                            <DivLayout
                              heading={"Permanent Address"}
                              data={
                                loanApplicationByIdResponse?.data?.primary
                                  ?.meta_data?.permanent_address
                                  ? loanApplicationByIdResponse?.data?.primary
                                      ?.meta_data?.permanent_address
                                  : localization.na
                              }
                            />
                          </div>
                          <div className="col-6">
                            <DivLayout
                              heading={"Residence Type"}
                              data={
                                loanApplicationByIdResponse?.data?.primary
                                  ?.meta_data?.residence_type
                                  ? loanApplicationByIdResponse?.data?.primary
                                      ?.meta_data?.residence_type
                                  : localization.na
                              }
                            />
                          </div>
                          <div className="col-6">
                            <DivLayout
                              heading={"Educational Qualification"}
                              data={
                                loanApplicationByIdResponse?.data?.primary
                                  ?.meta_data?.educational_qualification
                                  ? loanApplicationByIdResponse?.data?.primary
                                      ?.meta_data?.educational_qualification
                                  : localization.na
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            <div className="panel-card">
              <div className="panel-heading">Employee Details</div>
              <div className="panel-body">
                <div className="details-listing">
                  {loanApplicationByIdResponse?.data?.employment_details && (
                    <>
                      <div className="row">
                        <div className="col-6">
                          <DivLayout
                            heading={"Employee Type"}
                            data={
                              loanApplicationByIdResponse?.data
                                ?.employment_details?.employment_type
                                ? loanApplicationByIdResponse?.data
                                    ?.employment_details?.employment_type
                                : localization.na
                            }
                          />
                        </div>

                        <div className="col-6">
                          <DivLayout
                            heading={"Occupation"}
                            data={
                              loanApplicationByIdResponse?.data
                                ?.employment_details?.occupation
                                ? loanApplicationByIdResponse?.data
                                    ?.employment_details?.occupation
                                : localization.na
                            }
                          />
                        </div>
                        <div className="col-6">
                          <DivLayout
                            heading={"Annual Income"}
                            data={
                              loanApplicationByIdResponse?.data
                                ?.employment_details?.annual_income
                                ? loanApplicationByIdResponse?.data
                                    ?.employment_details?.annual_income
                                : localization.na
                            }
                          />
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className="panel-card">
              <div className="panel-heading">Vehicle Details</div>
              <div className="panel-body">
                <div className="details-listing">
                  {loanApplicationByIdResponse?.data && (
                    <>
                      <div className="row">
                        <div className="col-6">
                          <DivLayout
                            heading={"Vehicle Registration No"}
                            data={
                              loanApplicationByIdResponse?.data
                                ?.vehicle_registration_number
                                ? loanApplicationByIdResponse?.data
                                    ?.vehicle_registration_number
                                : localization.na
                            }
                          />
                        </div>
                        <div className="col-6">
                          <DivLayout
                            heading={"Vehicle Brand"}
                            data={
                              loanApplicationByIdResponse?.data?.vehicle_details
                                ?.vehicle_brand
                                ? loanApplicationByIdResponse?.data
                                    ?.vehicle_details?.vehicle_brand
                                : localization.na
                            }
                          />
                        </div>
                        <div className="col-6">
                          <DivLayout
                            heading={"Vehicle Model"}
                            data={
                              loanApplicationByIdResponse?.data?.vehicle_details
                                ?.vehicle_model
                                ? loanApplicationByIdResponse?.data
                                    ?.vehicle_details?.vehicle_model
                                : localization.na
                            }
                          />
                        </div>
                        <div className="col-6">
                          <DivLayout
                            heading={"Vehicle variant"}
                            data={
                              loanApplicationByIdResponse?.data?.vehicle_details
                                ?.vehicle_variant
                                ? loanApplicationByIdResponse?.data
                                    ?.vehicle_details?.vehicle_variant
                                : localization.na
                            }
                          />
                        </div>
                        <div className="col-6">
                          <DivLayout
                            heading={"Year of Manufacturing"}
                            data={
                              loanApplicationByIdResponse?.data?.vehicle_details
                                ?.year_of_manufacturing
                                ? loanApplicationByIdResponse?.data
                                    ?.vehicle_details?.year_of_manufacturing
                                : localization.na
                            }
                          />
                        </div>
                        <div className="col-6">
                          <DivLayout
                            heading={"Active Insurance"}
                            data={
                              loanApplicationByIdResponse?.data?.vehicle_details
                                ?.active_insurance
                                ? loanApplicationByIdResponse?.data
                                    ?.vehicle_details?.active_insurance
                                : localization.na
                            }
                          />
                        </div>
                        <div className="col-6">
                          <DivLayout
                            heading={"Insurance Validity"}
                            data={
                              loanApplicationByIdResponse?.data?.vehicle_details
                                ?.insurance_validity
                                ? loanApplicationByIdResponse?.data
                                    ?.vehicle_details?.insurance_validity
                                : localization.na
                            }
                          />
                        </div>
                        <div className="col-6">
                          <DivLayout
                            heading={"Engine Number"}
                            data={
                              loanApplicationByIdResponse?.data?.vehicle_details
                                ?.engine_number
                                ? loanApplicationByIdResponse?.data
                                    ?.vehicle_details?.engine_number
                                : localization.na
                            }
                          />
                        </div>

                        <div className="col-6">
                          <DivLayout
                            heading={"Chasis Number"}
                            data={
                              loanApplicationByIdResponse?.data?.vehicle_details
                                ?.chasis_number
                                ? loanApplicationByIdResponse?.data
                                    ?.vehicle_details?.chasis_number
                                : localization.na
                            }
                          />
                        </div>

                        <div className="col-6">
                          <DivLayout
                            heading={"Ownership Series"}
                            data={
                              loanApplicationByIdResponse?.data?.vehicle_details
                                ?.ownership_series
                                ? loanApplicationByIdResponse?.data
                                    ?.vehicle_details?.ownership_series
                                : localization.na
                            }
                          />
                        </div>

                        <div className="col-6">
                          <DivLayout
                            heading={"Fuel Type"}
                            data={
                              loanApplicationByIdResponse?.data?.vehicle_details
                                ?.fuel_type
                                ? loanApplicationByIdResponse?.data
                                    ?.vehicle_details?.fuel_type
                                : localization.na
                            }
                          />
                        </div>

                        <div className="col-6">
                          <DivLayout
                            heading={"Transmission Type"}
                            data={
                              loanApplicationByIdResponse?.data?.vehicle_details
                                ?.transmission_type
                                ? loanApplicationByIdResponse?.data
                                    ?.vehicle_details?.transmission_type
                                : localization.na
                            }
                          />
                        </div>

                        <div className="col-6">
                          <DivLayout
                            heading={"Current Hypothecation"}
                            data={
                              loanApplicationByIdResponse?.data?.vehicle_details
                                ?.current_hypothecation
                                ? loanApplicationByIdResponse?.data
                                    ?.vehicle_details?.current_hypothecation
                                : localization.na
                            }
                          />
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className="panel-card">
              <div className="panel-heading">Loan Details</div>
              <div className="panel-body">
                <div className="details-listing">
                  {loanApplicationByIdResponse?.data && (
                    <>
                      <div className="row">
                        <div className="col-6">
                          <DivLayout
                            heading={"Loan Amount"}
                            data={
                              loanApplicationByIdResponse?.data
                                ?.loan_required_amount
                                ? loanApplicationByIdResponse?.data
                                    ?.loan_required_amount
                                : localization.na
                            }
                          />
                        </div>
                        <div className="col-6">
                          <DivLayout
                            heading={"Net disbursal amount"}
                            data={
                              loanApplicationByIdResponse?.data
                                .loan_approved_amount
                                ? loanApplicationByIdResponse?.data
                                    ?.loan_approved_amount
                                : localization.na
                            }
                          />
                        </div>
                        <div className="col-6">
                          <DivLayout
                            heading={"Bank Name"}
                            data={
                              loanApplicationByIdResponse?.data?.bank_name
                                ? loanApplicationByIdResponse?.data?.bank_name
                                : localization.na
                            }
                          />
                        </div>
                        <div className="col-6">
                          <DivLayout
                            heading={"Loan Tenure"}
                            data={
                              loanApplicationByIdResponse?.data?.loan_tenure
                                ? loanApplicationByIdResponse?.data?.loan_tenure
                                : localization.na
                            }
                          />
                        </div>
                        <div className="col-6">
                          <DivLayout
                            heading={"Rate Of Interest"}
                            data={
                              loanApplicationByIdResponse?.data
                                ?.rate_of_interest
                                ? loanApplicationByIdResponse?.data
                                    ?.rate_of_interest
                                : localization.na
                            }
                          />
                        </div>
                        <div className="col-6">
                          <DivLayout
                            heading={"Loan Type"}
                            data={
                              loanApplicationByIdResponse?.data?.loan_type
                                ? loanApplicationByIdResponse?.data?.loan_type
                                : localization.na
                            }
                          />
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
            {/*
            {caseByIdResponse?.data &&
              caseByIdResponse?.data?.meta_data &&
              caseByIdResponse?.data?.meta_data[0] &&
              caseByIdResponse?.data?.meta_data[0]?.company_details && (
                <>
                  <div className="panel-card">
                    <div className="panel-heading">Company Details</div>
                    <div className="panel-body">
                      <div className="details-listing">
                        <div className="row">
                          <div className="col-6">
                            <DivLayout
                              heading={"Company Type"}
                              data={
                                caseByIdResponse?.data?.meta_data[0]
                                  ?.company_details?.company_type
                                  ? caseByIdResponse?.data?.meta_data[0]
                                      ?.company_details?.company_type
                                  : localization.na
                              }
                            />
                          </div>
                          <div className="col-6">
                            <DivLayout
                              heading={"Co-Application Relation"}
                              data={
                                caseByIdResponse?.data?.meta_data[0]
                                  ?.company_details?.co_application_relation
                                  ? caseByIdResponse?.data?.meta_data[0]
                                      ?.company_details?.co_application_relation
                                  : localization.na
                              }
                            />
                          </div>
                          <div className="col-6">
                            <DivLayout
                              heading={"Company Pan"}
                              data={
                                caseByIdResponse?.data?.meta_data[0]
                                  ?.company_details?.company_pan
                                  ? caseByIdResponse?.data?.meta_data[0]
                                      ?.company_details?.company_pan
                                  : localization.na
                              }
                            />
                          </div>
                          <div className="col-6">
                            <DivLayout
                              heading={"Company GST"}
                              data={
                                caseByIdResponse?.data?.meta_data[0]
                                  ?.company_details?.company_gst
                                  ? caseByIdResponse?.data?.meta_data[0]
                                      ?.company_details?.company_gst
                                  : localization.na
                              }
                            />
                          </div>
                          <div className="col-6">
                            <DivLayout
                              heading={"ESTD in (Year)"}
                              data={
                                caseByIdResponse?.data?.meta_data[0]
                                  ?.company_details?.estd_year
                                  ? caseByIdResponse?.data?.meta_data[0]
                                      ?.company_details?.estd_year
                                  : localization.na
                              }
                            />
                          </div>
                          <div className="col-6">
                            <DivLayout
                              heading={"Email"}
                              data={
                                caseByIdResponse?.data?.meta_data[0]
                                  ?.company_details?.email
                                  ? caseByIdResponse?.data?.meta_data[0]
                                      ?.company_details?.email
                                  : localization.na
                              }
                            />
                          </div>
                          <div className="col-6">
                            <DivLayout
                              heading={"Address"}
                              data={
                                caseByIdResponse?.data?.meta_data[0]
                                  ?.company_details?.address
                                  ? caseByIdResponse?.data?.meta_data[0]
                                      ?.company_details?.address
                                  : localization.na
                              }
                            />
                          </div>
                          <div className="col-6">
                            <DivLayout
                              heading={"Same for permanent address"}
                              data={
                                caseByIdResponse?.data?.meta_data[0]
                                  ?.company_details?.is_permanent_address
                                  ? caseByIdResponse?.data?.meta_data[0]
                                      ?.company_details?.is_permanent_address
                                  : localization.na
                              }
                            />
                          </div>
                          <div className="col-6">
                            <DivLayout
                              heading={"Mobile Number"}
                              data={
                                caseByIdResponse?.data?.meta_data[0]
                                  ?.company_details?.phone_no
                                  ? caseByIdResponse?.data?.meta_data[0]
                                      ?.company_details?.phone_no
                                  : localization.na
                              }
                            />
                          </div>
                          <div className="col-6">
                            <DivLayout
                              heading={"Company Turnover"}
                              data={
                                caseByIdResponse?.data?.meta_data[0]
                                  ?.company_details?.company_turnover
                                  ? caseByIdResponse?.data?.meta_data[0]
                                      ?.company_details?.company_turnover
                                  : localization.na
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )} */}

            {loanApplicationByIdResponse?.data &&
              loanApplicationByIdResponse?.data?.co_applicant &&
              loanApplicationByIdResponse?.data?.co_applicant?.meta_data && (
                <>
                  <div className="panel-card">
                    <div className="panel-heading">Co-Applicant Details</div>
                    <div className="panel-body">
                      <div className="details-listing">
                        <div className="row">
                          <div className="col-6">
                            <DivLayout
                              heading={"Co-Applicant First Name"}
                              data={
                                loanApplicationByIdResponse?.data?.co_applicant
                                  ?.meta_data?.first_name
                                  ? loanApplicationByIdResponse?.data
                                      ?.co_applicant?.meta_data?.first_name
                                  : localization.na
                              }
                            />
                          </div>
                          <div className="col-6">
                            <DivLayout
                              heading={"Co-Applicant Last Name"}
                              data={
                                loanApplicationByIdResponse?.data?.co_applicant
                                  ?.meta_data?.last_name
                                  ? loanApplicationByIdResponse?.data
                                      ?.co_applicant?.meta_data?.last_name
                                  : localization.na
                              }
                            />
                          </div>
                          <div className="col-6">
                            <DivLayout
                              heading={"Role in Company"}
                              data={
                                loanApplicationByIdResponse?.data?.co_applicant
                                  ?.meta_data?.co_applicant_role_in_company
                                  ? loanApplicationByIdResponse?.data
                                      ?.co_applicant?.meta_data
                                      ?.co_applicant_role_in_company
                                  : localization.na
                              }
                            />
                          </div>
                          <div className="col-6">
                            <DivLayout
                              heading={"Current Address"}
                              data={
                                loanApplicationByIdResponse?.data?.co_applicant
                                  ?.meta_data?.address
                                  ? loanApplicationByIdResponse?.data
                                      ?.co_applicant?.meta_data?.address
                                  : localization.na
                              }
                            />
                          </div>
                          <div className="col-6">
                            <DivLayout
                              heading={"Mobile Number"}
                              data={
                                loanApplicationByIdResponse?.data?.co_applicant
                                  ?.mobile_number
                                  ? loanApplicationByIdResponse?.data
                                      ?.co_applicant?.mobile_number
                                  : localization.na
                              }
                            />
                          </div>
                          <div className="col-6">
                            <DivLayout
                              heading={"Email"}
                              data={
                                loanApplicationByIdResponse?.data?.co_applicant
                                  ?.meta_data?.email
                                  ? loanApplicationByIdResponse?.data
                                      ?.co_applicant?.meta_data?.email
                                  : localization.na
                              }
                            />
                          </div>
                          <div className="col-6">
                            <DivLayout
                              heading={"Date of Birth"}
                              data={
                                loanApplicationByIdResponse?.data?.co_applicant
                                  ?.meta_data?.date_of_birth
                                  ? loanApplicationByIdResponse?.data
                                      ?.co_applicant?.meta_data?.date_of_birth
                                  : localization.na
                              }
                            />
                          </div>
                          <div className="col-6">
                            <DivLayout
                              heading={"Gender"}
                              data={
                                loanApplicationByIdResponse?.data?.co_applicant
                                  ?.meta_data?.gender
                                  ? loanApplicationByIdResponse?.data
                                      ?.co_applicant?.meta_data?.gender
                                  : localization.na
                              }
                            />
                          </div>
                          <div className="col-6">
                            <DivLayout
                              heading={"Education Qualification"}
                              data={
                                loanApplicationByIdResponse?.data?.co_applicant
                                  ?.meta_data?.educational_qualification
                                  ? loanApplicationByIdResponse?.data
                                      ?.co_applicant?.meta_data
                                      ?.educational_qualification
                                  : localization.na
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            <div className="panel-card">
              <div className="panel-heading">Additional Details</div>
              <div className="panel-body">
                <div className="details-listing">
                  <div className="row">
                    <div className="col-6">
                      <DivLayout
                        heading={"Rc Available"}
                        data={
                          loanApplicationByIdResponse?.data?.is_rc_available
                            ? loanApplicationByIdResponse?.data?.is_rc_available
                            : localization.na
                        }
                      />
                    </div>
                    <div className="col-6">
                      <DivLayout
                        heading={"Rc Transfer By"}
                        data={
                          loanApplicationByIdResponse?.data?.rc_transfer_by
                            ? loanApplicationByIdResponse?.data?.rc_transfer_by
                            : localization.na
                        }
                      />
                    </div>
                    {loanApplicationByIdResponse?.data?.documents?.form_26 && (
                      <div className="col-6">
                        <DocumentView
                          attachment={
                            loanApplicationByIdResponse?.data?.documents
                              ?.form_26
                          }
                          title={"Form 26"}
                        />
                      </div>
                    )}
                    {loanApplicationByIdResponse?.data?.documents
                      ?.bh_approval && (
                      <div className="col-6">
                        <DocumentView
                          attachment={
                            loanApplicationByIdResponse?.data?.documents
                              ?.bh_approval
                          }
                          title={"BH Approval"}
                        />
                      </div>
                    )}
                    {loanApplicationByIdResponse?.data?.documents?.fir && (
                      <div className="col-6">
                        <DocumentView
                          attachment={
                            loanApplicationByIdResponse?.data?.documents?.fir
                          }
                          title={"FIR"}
                        />
                      </div>
                    )}
                    {loanApplicationByIdResponse?.data?.documents
                      ?.undertaking && (
                      <div className="col-6">
                        <DocumentView
                          attachment={
                            loanApplicationByIdResponse?.data?.documents
                              ?.undertaking
                          }
                          title={"Undertaking"}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {loanApplicationByIdResponse?.data &&
              loanApplicationByIdResponse?.data?.documents && (
                <div className="panel-card">
                  <div className="panel-heading">Documents</div>
                  <div className="panel-body">
                    <div className="details-listing">
                      <div className="row">
                        {loanApplicationByIdResponse?.data &&
                          loanApplicationByIdResponse?.data?.documents &&
                          loanApplicationByIdResponse?.data?.documents?.rc && (
                            <div className="col-6">
                              <DocumentView
                                attachment={
                                  loanApplicationByIdResponse?.data?.documents
                                    ?.rc
                                }
                                title={"RC"}
                              />
                            </div>
                          )}
                        {loanApplicationByIdResponse?.data &&
                          loanApplicationByIdResponse?.data?.documents &&
                          loanApplicationByIdResponse?.data?.documents
                            ?.pan_card && (
                            <div className="col-6">
                              <DocumentView
                                attachment={
                                  loanApplicationByIdResponse?.data?.documents
                                    ?.pan_card
                                }
                                title={"Pan Card"}
                              />
                            </div>
                          )}
                        {loanApplicationByIdResponse?.data &&
                          loanApplicationByIdResponse?.data?.documents &&
                          loanApplicationByIdResponse?.data?.documents
                            ?.aadhar_card && (
                            <div className="col-6">
                              <DocumentView
                                attachment={
                                  loanApplicationByIdResponse?.data?.documents
                                    ?.aadhar_card
                                }
                                title={"Adhaar Card"}
                              />
                            </div>
                          )}
                        {loanApplicationByIdResponse?.data &&
                          loanApplicationByIdResponse?.data?.documents &&
                          loanApplicationByIdResponse?.data?.documents
                            ?.rent_agreement && (
                            <div className="col-6">
                              <DocumentView
                                attachment={
                                  loanApplicationByIdResponse?.data?.documents
                                    ?.rent_agreement
                                }
                                title={"Rent Agreement"}
                              />
                            </div>
                          )}

                        {loanApplicationByIdResponse?.data &&
                          loanApplicationByIdResponse?.data?.documents &&
                          loanApplicationByIdResponse?.data?.documents
                            ?.business_proof && (
                            <div className="col-6">
                              <DocumentView
                                attachment={
                                  loanApplicationByIdResponse?.data?.documents
                                    ?.business_proof
                                }
                                title={"Business proof (GST/MSME)"}
                              />
                            </div>
                          )}

                        {loanApplicationByIdResponse?.data &&
                          loanApplicationByIdResponse?.data?.documents &&
                          loanApplicationByIdResponse?.data?.documents
                            ?.electricity_bill && (
                            <div className="col-6">
                              <DocumentView
                                attachment={
                                  loanApplicationByIdResponse?.data?.documents
                                    ?.electricity_bill
                                }
                                title={"Electricity Bill"}
                              />
                            </div>
                          )}

                        {loanApplicationByIdResponse?.data &&
                          loanApplicationByIdResponse?.data?.documents &&
                          loanApplicationByIdResponse?.data?.documents
                            ?.salary_slip && (
                            <div className="col-6">
                              <DocumentView
                                attachment={
                                  loanApplicationByIdResponse?.data?.documents
                                    ?.salary_slip
                                }
                                title={`Salary Slip`}
                              />
                            </div>
                          )}

                        {loanApplicationByIdResponse?.data &&
                          loanApplicationByIdResponse?.data?.documents &&
                          loanApplicationByIdResponse?.data?.documents
                            ?.bank_statement && (
                            <div className="col-6">
                              <DocumentView
                                attachment={
                                  loanApplicationByIdResponse?.data?.documents
                                    ?.bank_statement
                                }
                                title={"Bank Statement"}
                              />
                            </div>
                          )}

                        {loanApplicationByIdResponse?.data &&
                          loanApplicationByIdResponse?.data?.documents &&
                          loanApplicationByIdResponse?.data?.documents
                            ?.insurance_certificate && (
                            <div className="col-6">
                              <DocumentView
                                attachment={
                                  loanApplicationByIdResponse?.data?.documents
                                    ?.insurance_certificate
                                }
                                title={"Insurance Certificate"}
                              />
                            </div>
                          )}

                        {loanApplicationByIdResponse?.data &&
                          loanApplicationByIdResponse?.data?.documents &&
                          loanApplicationByIdResponse?.data?.documents
                            ?.addition_documents && (
                            <div className="col-6">
                              <DocumentView
                                attachment={
                                  loanApplicationByIdResponse?.data?.documents
                                    ?.addition_documents
                                }
                                title={"Addition Doc"}
                              />
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
          </>
        )}
        <RTODocuments
          caseStatusUpdateResponse={caseStatusUpdateResponse}
          documentUploadUrlPublic={documentUploadUrlPublic}
          documentUrlDataPublic={documentUrlDataPublic}
          rcCaseByIdResponse={rcCaseByIdResponse}
          rcCaseByIdRequest={rcCaseByIdRequest}
          rtoDetailsUpdateRequest={rtoDetailsUpdateRequest}
          rtoDetailsUpdateResponse={rtoDetailsUpdateResponse}
          rtoInputList={rtoInputList}
          handleInput={handleInput}
          handleRtoInput={handleRtoInput}
          handleRTODetailsSubmit={handleRTODetailsSubmit}
          submitStatus={submitStatus}
          inputList={inputList}
        />
        <ModalPop
          title={"Change Status"}
          show={changeCarLoanStatusModalOpen}
          handleModalHide={() => {
            setChangeCarLoanStatusModalOpen(false);
          }}
        >
          <div className={s.root}>
              <div className="col-md-12">
                <DropDownInput
                  label={"Status"}
                  data={
                    rcCaseByIdResponse?.data &&
                    rcCaseByIdResponse?.data?.available_current_states
                      ? rcCaseByIdResponse?.data?.available_current_states
                      : []
                  }
                  value={""}
                  isStarRequired={true}
                  getIdValue={(val) => {
                    handleRtoInput("document_status", val.id);
                  }}
                  required={true}
                />
              </div>
              {rtoInputList[0]["document_status"] ===
                "ORIGINAL_DOCUMENT_APPROVED" && (
                <div className="col-sm-4 d-flex">
                  <input
                    type="checkbox"
                    name="vehicle1"
                    onChange={(e) => {
                      handleRtoInput(
                        "document_confirmation",
                        e.target.checked
                      );
                    }}
                    style={{
                      width: "6%",
                      marginTop: "-8px",
                      marginRight: "6px",
                    }}
                  />
                  <label htmlFor="Is All Documents is Collected">
                    Is All Documents is Collected
                  </label>
                  <br />
                </div>
              )}

              {rtoInputList[0]["document_status"] === "RTO_APPROVED" && (
                <div className="col-md-12 d-flex" style={{justifyContent: 'flex-end'}}>
                  <FileUpload
                    id={"RTO RECEIPT"}
                    accept=".pdf,.png,.jpg,.jpeg,.doc"
                    documentUploadUrl={documentUploadUrlPublic}
                    documentUrlData={documentUrlDataPublic}
                    onChange={(val) => handleRtoInput("RTO_RECEIPT", val)}
                    prefilledFilename={
                      rtoInputList[0] &&
                      rtoInputList[0]["url"] !== undefined
                        ? "RTO RECEIPT"
                        : ""
                    }
                  >
                    <span
                      className="btn btn-transparent btn-sm"
                    >
                      RTO RECEIPT
                      {/* <div style={{ color: "red" }}>*</div> */}
                    </span>
                  </FileUpload>
                </div>
              )}
              {rtoInputList[0]["document_status"] === "RTO_APPROVED" && (
                <div className="col-md-6">
                  <FileUpload
                    id={"Screenshot of Vahan"}
                    accept=".pdf,.png,.jpg,.jpeg,.doc"
                    documentUploadUrl={documentUploadUrlPublic}
                    documentUrlData={documentUrlDataPublic}
                    onChange={(val) =>
                      handleRtoInput("RC_TRANSFER_PROOF", val)
                    }
                    prefilledFilename={
                      rtoInputList[0] &&
                      rtoInputList[0]["url"] !== undefined
                        ? "Screenshot of Vahan"
                        : ""
                    }
                  >
                    <span
                      className="btn btn-transparent"
                    >
                      Screenshot of Vahan
                      <div style={{ color: "red" }}>*</div>
                    </span>
                  </FileUpload>
                </div>
              )}
              {/* <div className="col-sm-12 col-ms-12 ">
                <ConstantInput
                  label={localization.remark}
                  type="text"
                  value={""}
                  required={true}
                  className="my-custom-datepicker-component "
                  handleChange={(val) => handleRtoInput("remark", val)}
                />
              </div> */}

              <div className="col-md-6 d-flex">
                <Button 
                className="btn btn-primary btn-lg" 
                onClick={() => submitStatus()}
                >
                  {"Final Submit"}
                </Button>
              </div>
          </div>
        </ModalPop>
      </Fragment>
    </Layout>
  );
};

export default RTOCaseView;
